import { createSelector } from '@reduxjs/toolkit';

const selectUser = (state) => {
  return state.userState;
};

export const getUserAccessSelector = ({ module }) =>
  createSelector(selectUser, (userState) => {
    // Use extraArg in your logic if needed
    // const userData = userState.data[0];
    // const access = userData.access.find((m) => m.module === module);
    // if (access && access?.scope) {
    //   let scopes = access?.scope.split(',');
    //   return scopes;
    // }
    return ['add', 'edit', 'delete', 'list'];
    // return;
  });
